// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"gtKC6TiI1V9n","text":"_15EwQb1C5AtZ","button":"G_y6o8ktmypT"};